import { ThemeEvents } from '@theme/events';

class CartIcon extends HTMLElement {
  constructor() {
    super();
    this.cartCount = null;
    this.addToCartBehavior = null;
    this.lastInteraction = 0;

    this.clickHandler = this.handleClick.bind(this);
    this.cartUpdatedHandler = this.onCartUpdated.bind(this);
    this.interactionHandler = this.onInteraction.bind(this);
    this.resetInteractionHandler = this.resetInteraction.bind(this);
  }

  connectedCallback() {
    this.addToCartBehavior = this.dataset.addToCartBehavior || 'open_cart';

    this.cartCount = this.querySelector('[data-ref="cart-count"]');

    this.addEventListener('click', this.clickHandler);
    document.addEventListener(ThemeEvents.cartUpdated, this.cartUpdatedHandler);

    // On ne veut ouvrir le tiroir QUE suite a une action volontaire de l'utilisateur.
    // Les cart:updated automatiques (sync au chargement, offres, pre-rendu via speculation rules)
    // ne doivent pas ouvrir le tiroir tout seuls.
    document.addEventListener('pointerdown', this.interactionHandler, true);
    document.addEventListener('keydown', this.interactionHandler, true);
    window.addEventListener('pageshow', this.resetInteractionHandler);
    document.addEventListener('prerenderingchange', this.resetInteractionHandler);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdated, this.cartUpdatedHandler);
    this.removeEventListener('click', this.clickHandler);
    document.removeEventListener('pointerdown', this.interactionHandler, true);
    document.removeEventListener('keydown', this.interactionHandler, true);
    window.removeEventListener('pageshow', this.resetInteractionHandler);
    document.removeEventListener('prerenderingchange', this.resetInteractionHandler);
  }

  onInteraction() {
    this.lastInteraction = Date.now();
  }

  resetInteraction() {
    this.lastInteraction = 0;
  }

  getCurrentItemCount() {
    return parseInt(this.cartCount.textContent);
  }

  onCartUpdated(event) {
    const { itemCount, source, sections } = event.detail.data;

    if (typeof itemCount === 'number') {
      this.#setCount(itemCount);
    }

    const userInitiated = Date.now() - this.lastInteraction < 3000;

    if (this.addToCartBehavior === 'open_cart' && source !== 'cart-reservation-timer' && userInitiated) {
      this.openCart();
    }

    if (sections) return;

    setTimeout(() => {
      this.ensureCartCountIsCorrect();
    }, 100);
  }

  #setCount(count) {
    if (!this.cartCount) return;
    this.cartCount.textContent = count;
  }

  // Cette fonction est utile pour les applications de gift ou autre qui viennent modifier le panier pendant sa mise à jour. Ca permet de s'assurer que le compteur est correct.
  ensureCartCountIsCorrect() {
    const cartDrawer = document.querySelector('[data-ref="cart-drawer"]');
    if (!cartDrawer) return;

    let cartCount = 0;

    const cartItems = cartDrawer.querySelectorAll('[data-ref="cart-item"]');
    cartItems.forEach((cartItem) => {
      const input = cartItem.querySelector('[data-ref="quantity-selector-input"]');
      const quantity = parseInt(input?.value ?? cartItem.dataset.quantity ?? '0', 10);
      cartCount += Number.isNaN(quantity) ? 0 : quantity;
    });

    const nestedChildren = cartDrawer.querySelectorAll('[data-ref="cart-line-child"][data-quantity]');
    nestedChildren.forEach((child) => {
      const quantity = parseInt(child.dataset.quantity ?? '0', 10);
      cartCount += Number.isNaN(quantity) ? 0 : quantity;
    });

    if (cartCount != this.getCurrentItemCount()) {
      this.cartCount.textContent = cartCount;
    }
  }

  handleClick() {
    this.openCart();
  }

  openCart() {
    const cartDrawer = document.querySelector('[data-ref="cart-drawer"]');
    if (cartDrawer) {
      cartDrawer.open();
    } else {
      window.location.href = Theme.routes.cart_url;
    }
  }
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
